import { useEffect } from 'react'
import {
  useNativeHandlerAuthentication,
  useNativeHandlerOrderDetailsModal,
  useNativeHandlerSoundControl,
  useNativeHandlerStoreDetails,
} from './nativeApp.hooks'

/**
 * A hook that safely manages attaching and cleaning up native app handlers
 * on the global object for the lifetime of the component.
 */
export function useNativeAppHandlers() {
  const { openOrderDetailsModal } = useNativeHandlerOrderDetailsModal()
  const { getStoreDetails } = useNativeHandlerStoreDetails()
  const { getIsLoggedOut } = useNativeHandlerAuthentication()
  const { getIsSoundEnabled, enableNotificationSounds, disableNotificationSounds } = useNativeHandlerSoundControl()

  useEffect(() => {
    // Guard against running on the server
    if (typeof window === 'undefined') {
      return
    }

    // --- Attach all handlers to the window object ---

    window.openOrderDetailsModal = openOrderDetailsModal
    window.isLoggedOut = getIsLoggedOut
    window.getStoreDetails = getStoreDetails
    window.getSoundEnabledStatus = getIsSoundEnabled
    window.enableNotificationSounds = enableNotificationSounds
    window.disableNotificationSounds = disableNotificationSounds

    // --- Cleanup ---

    return () => {
      if ('openOrderDetailsModal' in window)
        delete (window as any).openOrderDetailsModal
      if ('getStoreDetails' in window)
        delete (window as any).getStoreDetails
      if ('getSoundEnabledStatus' in window)
        delete (window as any).getSoundEnabledStatus
      if ('isLoggedOut' in window)
        delete (window as any).isLoggedOut
      if ('enableNotificationSounds' in window)
        delete (window as any).enableNotificationSounds
      if ('disableNotificationSounds' in window)
        delete (window as any).disableNotificationSounds
    }
  }, [
    openOrderDetailsModal,
    getStoreDetails,
    getIsLoggedOut,
    getIsSoundEnabled,
    enableNotificationSounds,
    disableNotificationSounds,
  ])
}
